(function($){	
	$('a.close-btn').click(function(e){
		parent.history.back();
		e.preventDefault();
	});
})(jQuery);